import * as React from "react";
import { Modal, ModalFooter } from "@grandvisionhq/common";
import { Util } from "@grandvisionhq/forms";
import { useDispatch, useSelector } from "@grandvisionhq/state";
import { useBaseSummarySlot } from "../../../../slots/summaries/slots/summaries/summary-context.js";
import { ShippingObjectTypes } from "../../../../state.js";
import { updateShippingDetails } from "../../../../StepShipping/StepShipping/actions.js";
import { getShippingData, getCompanyFormData } from "../../../../StepShipping/StepShipping/selectors.js";
import { CheckoutForm } from "../../../../components/Forms/components/Forms/CheckoutForm.js";
import { FormFieldsWithCart } from "../../../../components/FormFieldsWithCart/components/FormFieldsWithCart/FormFieldsWithCart.js";
import { useIsFormSlotAvailable } from "../../../../slots/forms/slots/forms/form-context.js";
const EditableCompanySummary = ({ labels }) => {
  const isCompanyFormAvailable = useIsFormSlotAvailable(ShippingObjectTypes.Company);
  const [companyFormData, setCompanyFormData] = React.useState();
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const { Slots } = useBaseSummarySlot();
  const dispatch = useDispatch();
  const companyData = useSelector(getShippingData)?.company;
  const hasData = companyData && !Object.values(companyData).every((x) => x === null || x === "");
  const CompanySummarySlot = Slots.company;
  const companyFormDetails = useSelector(getCompanyFormData);
  if (!CompanySummarySlot && hasData) {
    console.error(
      "This opco is misconfigured. It has company data, but no company summary card setup."
    );
  }
  if (!CompanySummarySlot || !hasData) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, isCompanyFormAvailable && /* @__PURE__ */ React.createElement(
    Modal,
    {
      isOpen: isModalOpen,
      onModalClose: () => setIsModalOpen(false),
      showIcon: true,
      footer: /* @__PURE__ */ React.createElement(
        ModalFooter,
        {
          ctaCaption: labels?.editModal?.save,
          onCta: () => {
            if (!companyFormData?.formValid) {
              Util.focusToTopErrorFieldOnScreen();
            } else {
              companyFormData && dispatch(updateShippingDetails({ form: companyFormData }));
              setIsModalOpen(false);
            }
          },
          onCancel: () => setIsModalOpen(false)
        }
      )
    },
    /* @__PURE__ */ React.createElement(
      CheckoutForm,
      {
        formName: "company",
        "data-t": "company",
        initialFormState: companyFormDetails,
        onChange: (formData) => setCompanyFormData(formData)
      },
      /* @__PURE__ */ React.createElement(FormFieldsWithCart, { formName: ShippingObjectTypes.Company })
    )
  ), /* @__PURE__ */ React.createElement(CompanySummarySlot, { actions: { onEdit: () => setIsModalOpen(true) }, values: companyData }));
};
export {
  EditableCompanySummary,
  EditableCompanySummary as default
};
//# sourceMappingURL=EditableCompanySummary.js.map
